module.exports = __webpack_public_path__ + "img/truck_feature_01.df1493db.jpg";